import { StorePublicListingApi } from '../../generated/api';
import configuration from './configuration';

export default new StorePublicListingApi(configuration);
